const env = {
  SERVER: process.env.REACT_APP_API_URL,
  API_URL: process.env.REACT_APP_API_URL + '/api',
}

export default env
